package ui.screens.section.hero.composable

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.layout.ContentScale
import ui.theme.pinkBg

@Composable
fun EditorialBackground(
    alpha: Float,
    painter: Painter,
) {
    Box(Modifier.fillMaxSize()) {

        // 2️⃣ Background image
        Image(
            painter = painter,
            contentDescription = null,
            modifier = Modifier
                .fillMaxSize()
                .graphicsLayer { this.alpha = alpha }
            ,
            contentScale = ContentScale.Crop
        )

        // 3️⃣ Pink overlay
        Box(
            Modifier
                .fillMaxSize()
                .background(
                    pinkBg.copy(alpha = alpha * 0.7f)
                )
        )
    }
}